import React, { useState, useEffect } from "react";
import { object, array, bool } from "prop-types";

import Headline from "../../atoms/headline";
import StoryCard from "../story-card";
import ProgramThemes from "../../molecules/program-themes";
import ProjectStoryHeader from "../project-story-header";
import BlogStoryHeader from "../blog-story-header";
import ProjectStoryFooter from "../project-story-footer";
import MetypeCommentWrapper from "../../metype-comments";

import "./project-story.m.css";

const ProjectStoryView = ({ story, linkedStories, isBlog }) => {
  const [renderMetype, setRenderMetype] = useState(false);
  const sectionName = story.sections && story.sections[0] ? story.sections[0].name : "";
  const isPartnershipsSection = sectionName === "Partnerships";

  useEffect(() => setRenderMetype(true), []);

  return (
    <div className="story-grid">
      <div styleName="project-story" className="container">
        <div styleName="story-header-content">
          {isBlog ? <BlogStoryHeader story={story} /> : <ProjectStoryHeader story={story} />}
        </div>

        <div styleName="story-content">
          <div styleName="left-content">
            {story.subheadline && <Headline text={story.subheadline} headerType={9} headerLevel={2} />}

            {story.cards.map(card => (
              <StoryCard key={card.id} card={card} story={story} />
            ))}

            {isBlog ? null : <ProgramThemes story={story} />}

            {isBlog && renderMetype && !isPartnershipsSection ? (
              <div styleName="metype-widget">
                <MetypeCommentWrapper story={story} />
              </div>
            ) : null}
          </div>
          <div styleName="right-content">
            {story["hero-image-caption"] && <span styleName="hero-image-caption">{story["hero-image-caption"]}</span>}
          </div>
        </div>
      </div>

      {!isBlog && <ProjectStoryFooter story={story} linkedStories={linkedStories} />}
    </div>
  );
};

ProjectStoryView.defaultProps = {
  isBlog: false
};

ProjectStoryView.propTypes = {
  story: object,
  linkedStories: array,
  isBlog: bool
};

export default ProjectStoryView;
